const CARD_PADDING_TOP_DESKTOP = 24;
const CARD_PADDING_BOTTOM = 8;
const CARD_PADDING_BOTTOM_DESKTOP = 18;
const CARD_PADDING_RIGHT = 24;

export { CARD_PADDING_TOP_DESKTOP, CARD_PADDING_RIGHT, CARD_PADDING_BOTTOM, CARD_PADDING_BOTTOM_DESKTOP };
